import { createAction, handleActions } from "redux-actions";

const SET = 'timeCount.SET';
const CLEAR = 'timeCount.CLEAR';

const defaultState = {
  totalAnsweringTime : 0,
  answeringTime : 0,
  inputTime : 0
};

const setTimeCountAction = createAction( SET, payload => payload );
const clearTimeCountAction = createAction( CLEAR );

const timeCount = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default timeCount;
export { setTimeCountAction, clearTimeCountAction };
